import { Toast } from "vant";
// 格式化时间
export const FormatDate = (date, fmt) => {
  if (date === null || date === undefined || date === "") {
    return "";
  }
  let dateData = new Date(date);
  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, (dateData.getFullYear() + "").substr(4 - RegExp.$1.length));
  }
  let o = {
    "M+": dateData.getMonth() + 1,
    "d+": dateData.getDate(),
    "h+": dateData.getHours(),
    "m+": dateData.getMinutes(),
    "s+": dateData.getSeconds()
  };
  for (let k in o) {
    if (new RegExp(`(${k})`).test(fmt)) {
      let str = o[k] + "";
      fmt = fmt.replace(RegExp.$1, RegExp.$1.length === 1 ? str : padLeftZero(str));
    }
  }

  function padLeftZero(str) {
    return ("00" + str).substr(str.length);
  }
  return fmt;
};

export const isEmptyStr = value => {
  return value === undefined || value === null || value === "";
};

export const regMobile = mobile => {
  //验证手机
  let pattern = /^1\d{10}$/;
  return pattern.test(mobile);
};

// 粘贴数据结构
export const getExcelData=(excelData, dataMap, type) => {
  let rows = excelData
    .split("\n")
    .filter(function (item) {
      //兼容Excel行末\n，防止出现多余空行
      return item !== "";
    })
    .map(function (item) {
      var arrs = item.split(item.indexOf("\t") != -1 ? "\t" : /,|，/);
      //arrs.forEach((e,idx)=>arrs[idx]=e.trim())
      return arrs.map(e => e.trim());
    });

  // 处理头部
  let rowsHeader = rows[0];
  let newRowsHeader = [];

  // 验证头部
  if (type === "Order" || type === "Commodity") {
    rowsHeader.forEach(item => {
      if (item.indexOf("型号") !== -1) {
        item = "型号";
      }
      if (item.indexOf("净重") !== -1) {
        item = "净重";
      }
      if (item.indexOf("毛重") !== -1) {
        item = "毛重";
      }
      if (item.indexOf("品牌") !== -1) {
        item = "品牌";
      }
      if (item.indexOf("品名") !== -1) {
        item = "品名";
      }
      if (item.indexOf("数量") !== -1) {
        item = "数量";
      }
      if (item.indexOf("单价") !== -1) {
        item = "单价";
      }
      newRowsHeader.push(item);
    });
  }
  if (type === "HKOrder") {
    rowsHeader.forEach(item => {
      if (item.indexOf("型号") !== -1) {
        item = "型号";
      }
      if (item.indexOf("品名") !== -1) {
        item = "品名";
      }
      if (item.indexOf("年份") !== -1) {
        item = "年份";
      }
      if (item.indexOf("净重") !== -1) {
        item = "净重";
      }
      if (item.indexOf("毛重") !== -1) {
        item = "毛重";
      }
      newRowsHeader.push(item);
    });
  }
  let err = "";
  if (type === "Order") {
    if (!newRowsHeader.includes("品牌")) {
      err = "数据中必须存在品牌";
    } else if (!newRowsHeader.includes("型号")) {
      err = "数据中必须存在型号";
    } else if (!newRowsHeader.includes("数量")) {
      err = "数据中必须存在数量";
    } else if (!newRowsHeader.includes("单价")) {
      err = "数据中必须存在单价";
    }
    // else if (!newRowsHeader.includes("币别")) {
    //   err = "数据中必须存在币别";
    // }
  }
  if (type === "HKOrder") {
    if (!newRowsHeader.includes("型号")) {
      err = "数据中必须存在型号";
    } else if (!newRowsHeader.includes("数量")) {
      err = "数据中必须存在数量";
    }
  }
  if (err) {
    Toast.fail(err);
    return null;
  }

  // 解析数据
  rows.shift();
  const converters = newRowsHeader.map(column => {
    return (item, value) => {
      item[column] = value;
      return item;
    };
  });
  let items = rows.map(row => {
    console.log(row);
    const cells = row;
    const item = {};
    cells.forEach((value, index) => {
      if (index >= converters.length) {
        return;
      }
      converters[index](item, value);
    });

    return item;
  });

  let newItems = [];

  items.forEach(item => {
    let newItem = {};
    Object.entries(item).forEach(([key, value]) => {
      newItem[dataMap[key]] = value;
    });
    newItems.push(newItem);
  });

  return newItems;
}
